import { render, staticRenderFns } from "./newsletterA.vue?vue&type=template&id=2ede74ee"
import script from "./newsletterA.vue?vue&type=script&lang=js"
export * from "./newsletterA.vue?vue&type=script&lang=js"
import style0 from "./newsletterA.vue?vue&type=style&index=0&id=2ede74ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports